import React from 'react'


export default function ProgressBar(props) {
    
    const maxNumOfPages = 12;
    // Phones move one question at a time (questionNumber 1-30); question 30 shows 97% until submitted.
    // Other forms (profile) pass their own title, percent and statusText.
    const percentageNum = props.percent !== undefined ? props.percent : props.questionNumber
        ? Math.round(props.questionNumber * 100 / 31)
        : Math.round((props.pageNum-1) * (100/(maxNumOfPages-1)));
    const progressBarStyle = {
        width: `${percentageNum}%`
    }

    // Pages 2-11 hold questions 1-3, 4-6, ... 28-30 (IMP-080)
    const firstQuestion = (props.pageNum - 2) * 3 + 1;
    const statusText = props.statusText ? props.statusText : (props.pageNum === 1) ? "Takes about 5 minutes · 30 quick questions"
        : props.questionNumber ? `Question ${props.questionNumber} of 30`
        : (props.pageNum < 12) ? `Questions ${firstQuestion}–${firstQuestion + 2} of 30`
            : "All 30 questions answered";
    
    return (
        <div className="ProgressBar">
            <div className="ProgressBar--text">
                <h1 className="ProgressBar--title">{props.title || "Cofounders Matching Tool"}</h1>
                <p className="ProgressBar--percentage">{percentageNum}%</p>
            </div>
            <div className="ProgressBar--container">
                <div className="ProgressBar--bar"></div>
                <div className="ProgressBar--active" style={progressBarStyle}></div>
            </div>
            <p className="ProgressBar--status">{statusText}</p>
        </div>
    )
}